import classNames from 'classnames';
import React from 'react';
import { ContextMenuTrigger, ContextMenuTriggerProps } from 'react-contextmenu';
import SortAscending from '../../../assets/icomoon/sort-amount-asc.svg?react';
import SortDescending from '../../../assets/icomoon/sort-amount-desc.svg?react';
import PlaylistColumns, {
  ColumnSettings,
  TrackProperty,
} from '../../../services/columnSettings/playlistColumns';
import Constants from '../../../settings';
import s from '../../playlist/playlist.module.scss';
import { SortDirection } from '../streamingServiceCommon/searchResultSorting';

interface Props {
  customName?: string;
  columnKey: TrackProperty | 'size' | 'image';
  columnSettings: Partial<ColumnSettings>;
  contextMenuTriggerRef: React.Ref<React.Component<ContextMenuTriggerProps, any, any>>;
  onResizeStart: (ev: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => void;
  columnAutoResize(ev: React.MouseEvent<HTMLDivElement>): void;
  toggleMenu: (e: React.MouseEvent) => void;
  /**
   * Sort by this column. Absent where the list cannot sort - a column with
   * no handler is a plain header, which is what every list using this was
   * until the search results learned to sort.
   */
  onSort?: (ev: React.MouseEvent) => void;
  /** Set only on the column the list is currently sorted by. */
  sortDirection?: SortDirection;
}

export default function ItemListColumn({
  customName,
  columnKey,
  columnSettings,
  contextMenuTriggerRef,
  onResizeStart,
  columnAutoResize,
  toggleMenu,
  onSort,
  sortDirection,
}: Props) {
  const name = customName || PlaylistColumns[columnKey].name;

  return (
    <div
      className={classNames(s.headerColumn, {
        [s.hideOnHover]: columnSettings[columnKey]!.width < Constants.HeaderHideBreakpoint,
        [s.activeFilter]: sortDirection === 'ascending',
        [s.activeFilterDesc]: sortDirection === 'descending',
      })}
      style={{ width: columnSettings[columnKey]?.width }}
      data-column-name={columnKey}
    >
      <ContextMenuTrigger
        ref={contextMenuTriggerRef}
        id="cloudprovider-context-menu"
        holdToDisplay={-1}
        disableIfShiftIsPressed
      >
        {onSort ? (
          <div onClick={onSort}>
            <span className="header-column-content">{name}</span>
          </div>
        ) : (
          <span className="header-column-content">{name}</span>
        )}
      </ContextMenuTrigger>
      {onSort && (
        // The same control the playlist header carries, so sorting looks the
        // same wherever it is offered.
        <button className={classNames(s.menuBtn, s.hiddenColControls)} onClick={onSort}>
          {sortDirection === 'ascending' ? (
            <SortDescending fill="white" />
          ) : (
            <SortAscending fill="white" />
          )}
        </button>
      )}
      <button className={classNames(s.menuBtn, 'invisible-control')} onClick={toggleMenu}>
        ☰
      </button>
      <div
        className={s.resizeColumn}
        onMouseDown={onResizeStart}
        onDoubleClick={columnAutoResize}
        onTouchStart={onResizeStart}
      />
    </div>
  );
}
